import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import BasketEmpty from '@/ui/views/checkout/BasketEmpty.vue';
import BasketCoupon from '@/ui/views/checkout/BasketCoupon.vue';
import BasketFreeShipping from '@/ui/views/checkout/BasketFreeShipping.vue';
import BasketTitle from '@/ui/views/checkout/BasketTitle.vue';
import { SiteMode } from './site-mode';
import BasketPageViewModel = Vertica.LouisPoulsen.Application.Content.Pages.Basket.Consumer.BasketPageViewModel;
import BasketViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Consumer.BasketViewModel;
import BasketSummaryB2C from '@/ui/views/checkout/BasketSummaryB2C.vue';
import BasketLineItemB2C from '@/ui/views/checkout/BasketLineItemB2C.vue';
import BasketGiftLineItemB2C from '@/ui/views/checkout/BasketGiftLineItemB2C.vue';
import BasketPromotionBanner from '@/ui/shared/BasketPromotionBanner.vue';
import BasketFreeItem from '@/ui/views/checkout/BasketFreeItem.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketB2C',
  props: {
    model: null
  },
  setup(__props: any) {



const basket = computed<BasketViewModel>(() => store.getters['basket/basket']);
const hasPromotionBanner = computed<boolean>(() => store.getters['basket/hasPromotionBanner']);
const checkoutUrl = computed<string>(() => store.getters['app/checkoutUrl']);

function fetchBasket() {
    store.dispatch('basket/fetchBasket');
}
fetchBasket();

const basketIsEmpty = computed<boolean>(() => {
    const lineItemCount = basket.value.lineItems.length;
    return lineItemCount === 0;
});
const basketHasItems = computed<boolean>(() => {
    const lineItemCount = basket.value.lineItems.length;
    return lineItemCount !== 0;
});
const hasFreeShipping = computed<boolean>(() => {
    return basket.value.freeShipping;
});

const siteMode = SiteMode;

return { __sfc: true,basket, hasPromotionBanner, checkoutUrl, fetchBasket, basketIsEmpty, basketHasItems, hasFreeShipping, siteMode, BasketEmpty, BasketCoupon, BasketFreeShipping, BasketTitle, BasketSummaryB2C, BasketLineItemB2C, BasketGiftLineItemB2C, BasketPromotionBanner, BasketFreeItem }
}

})